import React, {useState} from 'react';
import Modal from "../../components/modal/modal";
import {COURSE_ACCESS_CLASS_CODE} from "../../lib/constant";

const InviteModal = ({url, clazzCourseId, clazzCode, access, onClose}) => {
    return (
        <Modal
            title={window.L("teach.course.inviteToJoin")}
            tips={window.L("teach.course.inviteToJoinTips")}
            onClose={onClose}
            >
            <div style={{marginTop: "1rem"}}>
                <p style={{backgroundColor: "#efefef", padding: "1rem"}}>
                    班级ID：{clazzCourseId}<br/><br/>
                    班级码：{clazzCode}<br/><br/>
                    方法1：登录后点击导航栏『我的班级』，点击『加入班级』，输入班级码：{clazzCode}，进入报名页。<br/><br/>
                    方法2：直接访问报名页链接，输入班级码：<br/>{`${url}&type=1`}<br/>
                </p>
            </div>


        </Modal>
    );
}

export default InviteModal;